import template from './general-business-review-details.html';
import controller from './general-business-review-details.controller';

let generalBusinessReviewDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default generalBusinessReviewDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/general-business-review-details/general-business-review-details.component.js